import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  DesignAngularKitModule,
  ItModalComponent,
  ItNotificationService,
  NotificationPosition,
} from 'design-angular-kit';
import { FindRequestDto } from '../../models/find-request.dto';
import { REQUEST_STATUS_OPTIONS } from '../../models/request-status.constants';
import { SettingDto, SubSettingDto } from '../../models/request.dto';
import { RequestService } from '../../services/request.service';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { AslDetails } from '../../services/context.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-filter',
  standalone: true,
  imports: [
    CommonModule,
    DesignAngularKitModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
})
export class FilterComponent {
  @Output() filtersSubmitted = new EventEmitter<any>();
  @Input() filters!: FindRequestDto;
  @ViewChild('rightModal') rightModal!: ItModalComponent;

  formFilters!: FormGroup;
  activeFilters: any = {};
  settings: SettingDto[] = [];
  asls: AslDetails[] = [];
  selectedSetting: any;
  selectedAsl: any;
  operatoreMMg: boolean = false;

  requestStatusOptions = REQUEST_STATUS_OPTIONS;

  chipFields = [
    { key: 'patientFiscalCode', label: 'Codice fiscale' },
    { key: 'patientName', label: 'Nome' },
    { key: 'patientSurname', label: 'Cognome' },
    { key: 'code', label: 'N Pratica' },
    { key: 'statusCodes', label: 'Stato richiesta' },
    { key: 'subsettingIds', label: 'Setting' },
    { key: 'startDate', label: 'Data richiesta da' },
    { key: 'endDate', label: 'Data richiesta a' },
    { key: 'aslCode', label: 'Asl' },
  ];

  constructor(
    private fb: FormBuilder,
    private requestService: RequestService,
    private notification: ItNotificationService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.operatoreMMg = this.authService.isOperatoreMmg;
    this.getSettings();
    this.getAsls();
    this.formFilters = this.fb.group({
      patientFiscalCode: [
        this.filters.patientFiscalCode ? this.filters.patientFiscalCode : null,
      ],
      startDate: [this.filters.startDate ? this.filters.startDate : null,
      ],
      endDate: [this.filters.endDate ? this.filters.endDate : null,
      ],
      patientName: [this.filters.patientName ? this.filters.patientName : null],
      patientSurname: [
        this.filters.patientSurname ? this.filters.patientSurname : null,
      ],
      statusCodes: [this.filters.statusCodes ? this.filters.statusCodes : []],
      withCurrentUserOwnership: [
        this.filters.transitionFindOwnershipRequest?.withCurrentUserOwnership
          ? this.filters.transitionFindOwnershipRequest
              ?.withCurrentUserOwnership
          : null,
      ],
      withPastUserOwnership: [
        this.filters.transitionFindOwnershipRequest?.withPastUserOwnership
          ? this.filters.transitionFindOwnershipRequest
              ?.withCurrentUserOwnership
          : null,
      ],
      subsettingIds: [
        this.filters.subsettingIds ? this.filters.subsettingIds : null,
      ],
      aslCode: [
        this.filters.aslCode ? this.filters.aslCode : null,
      ],
      code: [this.filters.code ? this.filters.code : null],
    });
    if(this.operatoreMMg) {
      this.formFilters.controls['patientFiscalCode'].disable();
    }
    this.activeFilters = { ...this.formFilters.value };
  }

  onSubmitFilters() {
    const statusCodes = this.formFilters.get('statusCodes')?.value;
    if (!statusCodes || statusCodes.length === 0) {
      this.notification.warning(
        'Attenzione.',
        'Selezionare almeno uno stato della richiesta per effettuare la ricerca.',
        true,
        3000,
        NotificationPosition.Top
      );
      return;
    }

    if (this.formFilters.valid) {
      console.log(this.formFilters.controls['patientFiscalCode'].value)
      if(this.formFilters.controls['patientFiscalCode'].value === '') {
        this.formFilters.controls['patientFiscalCode'].setValue(null);
      }
      if(this.formFilters.controls['patientName'].value === '') {
        this.formFilters.controls['patientName'].setValue(null);
      }
      if(this.formFilters.controls['patientSurname'].value === '') {
        this.formFilters.controls['patientSurname'].setValue(null);
      }
      if(this.formFilters.controls['code'].value === '') {
        this.formFilters.controls['code'].setValue(null);
      }
      if(this.formFilters.controls['aslCode'].value === 'null') {
        this.formFilters.controls['aslCode'].setValue(null);
      }
      this.formFilters.controls['patientFiscalCode'].enable();
      this.activeFilters = { ...this.formFilters.value };
      console.log(this.activeFilters)
      this.filtersSubmitted.emit(this.activeFilters);
      if(this.operatoreMMg) {
        this.formFilters.controls['patientFiscalCode'].disable();
      }
      this.rightModal.hide();
    }
  }

  get activeChips() {
    return this.chipFields
      .map((f) => {
        const value = this.activeFilters[f.key];
        if (value && value.length !== 0) {
          let displayValue = value;

          if (f.key === 'statusCodes' && Array.isArray(value)) {
            const labelMap = this.requestStatusOptions.reduce((acc, opt) => {
              acc[opt.value] = opt.label;
              return acc;
            }, {} as Record<string, string>);
            displayValue = this.isAllStatusSelected(value)
              ? 'Tutti'
              : value.map((v: string) => labelMap[v] || v).join(', ');
          } else if (f.key === 'subsettingIds') {
            const settingName =
              this.settings.find((s) => s.code === this.selectedSetting)
                ?.name ?? 'N/A';
            displayValue = settingName;
          } else if (f.key === 'aslCode') {
            const aslName =
              this.asls.find((s) => s.code === this.selectedAsl)
                ?.name ?? 'N/A';
            displayValue = aslName;
          } else if(f.key === 'startDate') {
            displayValue = this.formatDateIT(this.formFilters.controls['startDate'].value);
          } else if(f.key === 'endDate') {
            displayValue = this.formatDateIT(this.formFilters.controls['endDate'].value);
          } else if (Array.isArray(value)) {
            displayValue = value.join(', ');
          }

          return {
            key: f.key,
            label: `${f.label}: ${displayValue}`,
          };
        }
        return null;
      })
      .filter((chip) => chip !== null);
  }

  formatDateIT(dateStr: string | null): string {
      if (!dateStr) return '';
      return format(new Date(dateStr), 'dd/MM/yyyy', { locale: it });
    }

  private isAllStatusSelected(selected: string[]): boolean {
    const allCodes = this.requestStatusOptions.map((o) => o.value).sort();
    const selectedSorted = [...selected].sort();
    return (
      selected.length === allCodes.length &&
      selectedSorted.every((v, i) => v === allCodes[i])
    );
  }

  removeFilterField(key: string) {
    const control = this.formFilters.get(key);
    control?.reset(Array.isArray(control?.value) ? [] : '');
    delete this.activeFilters[key];
    this.filtersSubmitted.emit(this.activeFilters);
  }

  onModalClosed() {
    this.formFilters.reset();
    if (this.activeFilters) {
      this.formFilters.patchValue(this.activeFilters);
    }
  }

  onCheckboxChange(event: Event, value: string) {
    const checked = (event.target as HTMLInputElement).checked;
    this.onStatusChange(value, checked);
  }

  onStatusChange(value: string, checked: boolean) {
    const currentValues = this.formFilters.get('statusCodes')?.value || [];
    if (checked) {
      this.formFilters.get('statusCodes')?.setValue([...currentValues, value]);
    } else {
      this.formFilters
        .get('statusCodes')
        ?.setValue(currentValues.filter((v: string) => v !== value));
    }
  }

  getAsls() {
    this.requestService.getAllAslInfo().subscribe((response) => {
      if (response) {
        this.asls = response as AslDetails[];
      }
    });
  }

  getSettings() {
    this.requestService.getAllSettings().subscribe((response) => {
      if (response) {
        this.settings = response as SettingDto[];
      }
    });
  }

  getSubsettings(): SubSettingDto[] {
    return (
      this.settings.find((setting) => setting.code === this.selectedSetting)
        ?.subSettings || []
    );
  }

  onSelectedSetting(event: any) {
    this.formFilters.controls['subsettingIds'].setValue([]);
    this.getSubsettings().forEach((subsetting) =>
      this.formFilters.controls['subsettingIds'].value.push(subsetting.id)
    );
  }

  onSelectedAsl(event: any) {
    this.formFilters.controls['aslCode'].setValue(event);
  }

  selectAllStatuses(event: Event) {
    event.preventDefault();
    const allStatusValues = this.requestStatusOptions.map((s) => s.value);
    this.formFilters.get('statusCodes')?.setValue(allStatusValues);
  }

  deselectAllStatuses(event: Event) {
    event.preventDefault();
    this.formFilters.get('statusCodes')?.setValue([]);
  }
}
